// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3NLYY","buttons":"SendReceipts_buttons__Ljg5u","email":"SendReceipts_email__2U_rx","bookApptTitle":"SendReceipts_bookApptTitle__Fj8D2"};